module.exports = __webpack_public_path__ + "static/media/edit.29b32133.svg";